import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { SessionType, clientUserSignInLinkByEmail, getBaseUrl } from '@shared';
import { selectSession } from '@client/model';

export function AuthSignout() {
  const { logout, user } = useAuth0();
  const session = useSelector(selectSession);
  const isClient = session.sessionType === SessionType.client;

  useEffect(() => {
    logout({
      logoutParams: {
        returnTo: isClient
          ? clientUserSignInLinkByEmail(user?.email)
          : `${getBaseUrl()}?email_hint=${encodeURIComponent(user?.email ?? '')}`,
      },
    });
  }, []);

  return null;
}
